import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";
const axiosInstance = getAxiosInstance();

export const makeOneClickPayment = ({
  recipientId,
  amount,
  context,
  postId,
  messageId,
  modelId,
  description,
}) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .post(
        "/api/ccbill/payment/oneclick",
        {
          recipientId,
          amount,
          context,
          postId,
          messageId,
          modelId,
          description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};

export const getLast4ForRecipient = (recipientId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/ccbill/payment-token/${recipientId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};
export const getAllTokens = () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/ccbill/payment-tokens", {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};
export const deleteToken = (tokenId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/ccbill/payment-tokens/${tokenId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};
export const updateToken = (tokenId, isEnabled) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .patch(
        `/api/ccbill/payment-tokens/${tokenId}`,
        { isEnabled },
        {
          headers: {
            "Content-Type": "application/json",
            [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
            [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
              `Bearer ${tokens.firebase_token}`,
            "ngrok-skip-browser-warning": "true",
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};

export const cancelSubscriptionAPI = (creatorId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .delete(`/api/ccbill/payment/subscriptions/${creatorId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};
export const getSubscriptionStatusAPI = (creatorId) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get(`/api/ccbill/payment/subscription/${creatorId}`, {
        headers: {
          "Content-Type": "application/json",
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err));
  });
};
